import axios from "axios";
import { initGlobalAxiosSettings } from "./initGlobalAxiosSettings";

export function initGlobalAxios() {
	initGlobalAxiosSettings(axios);
}
